module.exports = __webpack_public_path__ + "static/testimonial-thumb-3-f6332d1e9f5801bdabd9839e598211a0.jpg";